import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {white, darkBlue, marketingMobileCuttoff, marketingMobileCuttoffMax} from "@css/constants";
import {FontNormal} from "@css/fonts";
import {fontSize} from "@css/styles";

export type CallToActionWrapperProps = {
  buttonFullWidth?: boolean
  desktopOnly?: boolean
  mobileOnly?: boolean
}

export const MembershipSectionContainer = styled('div')(css`
  margin: 0;
  display: flex;
`)

export type MembershipSectionWrapperBlockProps = {
  paddingHorizontal?: string
  forceHorizontalLayout?: boolean
}

export const MembershipSectionWrapper = styled('div')<MembershipSectionWrapperBlockProps>((props) => css`
  background: ${darkBlue};
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-top: 0;
  padding-bottom: 0;

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: ${props.forceHorizontalLayout ? 'row' : 'column' };
    align-items: center;
  }
`)

export const MembershipContentWrapper = styled('div')(css`
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 100px 0;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding: 20px 0;
  }
`)

export type MembershipSectionBlockProps = {
  center?: boolean
  paddingVertical?: string
  paddingHorizontal?: string
  width?: string
}

export const MembershipSectionBlock = styled('div')<MembershipSectionBlockProps>((props) => css`
  width: 50%;
  float: left;
  flex-direction: column;
  justify-content: space-evenly;
  text-align: ${props.center ? 'center' : ''};
  color: ${white};

  hr {
    width: 88%;
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    padding-left: 0;
  }
`)

export const ListParagraph = styled('p')(css`
  ${FontNormal(700)};
  ${fontSize(20)};
  font-style: italic;
  line-height: 24px;
  text-align: center;
  padding: 21.5px 0;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
    line-height: 19px;
  }
`)

export const MembershipSectionText = styled('div')<{ bold?: boolean }>((props) => css`
  color: ${white};
  
  h1 {
    ${FontNormal(700)};
    ${fontSize(32)};
    line-height: 32px;
    max-width: 330px;

    @media(max-width: ${marketingMobileCuttoff}) {
      margin-top: 32px;
      ${fontSize(24)};
      line-height: 24px;
    }
  }
  
  h3 {
    ${FontNormal(700)};
    ${fontSize(20)};
    line-height: 24px;
  }
  
  p {
    ${FontNormal(400)};
    ${fontSize(20)};
    line-height: 24px;
    margin-top: 20px;

    @media(max-width: ${marketingMobileCuttoff}) {
      ${fontSize(16)};
      line-height: 19px;
    }
  }
  
  span {
    ${FontNormal(400)};
    ${fontSize(12)};
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    padding-left: 0;
  }
`)

export const CallToActionButtonWrapper = styled('div')<CallToActionWrapperProps>((props) => css`
  margin-top: 20px;
  width: 100%;
  max-width: 330px;
  
  @media(min-width: ${marketingMobileCuttoffMax}) {
    display: ${props.mobileOnly ? 'none' : 'block' };
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    max-width: none;
    display: ${props.desktopOnly ? 'none' : 'block' };
    margin-bottom: 40px;
    ${props.buttonFullWidth ? `width: 100%;` : ''}
  }
`)



